import Navstyle from "./Navbar.module.css";
import {
  Box,
  Flex,
  Avatar,
  HStack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  useMediaQuery,
  VStack,
  Link,
  useDisclosure,
  useBreakpointValue,
  IconButton,
} from "@chakra-ui/react";
import {  useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Login from "../../Pages/Landing/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { LogOutAction } from "./LoginAction/LogOutAction";
import { BenDataProps } from "../../Helper/BenInterface";
import { getDocument } from "../../http";
import { wordpressBaseUrl } from "../../wordpressApiConfig/wordpressApiConfig";
import { LoginButtonWithDropdown } from "../../Pages/Common/Component/LoginButtonWithDropdown.component";
import styles from "../../Pages/Common/Style/Style.module.css"
import { getObjectUrlFromBlob } from "../../GlobalActions/getImageFromBlob";
import { getImageBaseUrl } from "../../Helper/env";


interface SubscriberData {
  subscriber: BenDataProps;
}

const Navbar: React.FC = () => {

  const wpBaseUrl = wordpressBaseUrl();
  const location = useLocation();
  const [loginModal, setLoginModal] = useState(false);
  const [pocoLogo,setPocoLogo] = useState("");
  // const [menuOpen, setMenuOpen] = useState(false); 
   const [image,setImage]=useState("")
  // const { state } = location;
  const subscriberData = useSelector(
    (state: SubscriberData) => state.subscriber
  );
  const benificiaryData = useSelector((state: any) => state.beneficiary);
  const [isLargerThan768] = useMediaQuery("(min-width: 860px)");

  const loginData = benificiaryData.filter((el: any) => {
    return subscriberData?._id === el._id;
  });   
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const openModal = () => {
  //   setLoginModal(true);
  // };

  const closeModal = () => {
    setLoginModal(false);
  };

  const logoutHandler = async () => {
    await LogOutAction(subscriberData.userId, dispatch);
  };

  const handleLogoClick = () => {
    if (!benificiaryData.length) {
      navigate(`${wpBaseUrl}/home/`);
    } else {
      navigate("/dashboard");
    }
  };

  const handleProfileClick = () => {
    if (subscriberData) return navigate(`/profile/view/${subscriberData._id}`);
  };

  const handleOrdersClick = () => {
    return navigate("/orders");
  };

  const handleTicketsClick = () => {
    return navigate("/tickets");
  };

  // const toggleMenu = () => {
  //   setMenuOpen(!menuOpen); // Toggle the menu's visibility
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const loadLogo = async () => {
        const url = await getObjectUrlFromBlob(`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/logos/pococare-logo.png`);
        setPocoLogo(url);
    };
    loadLogo();
}, []);

  useEffect(()=>{
    const fetchphoto=async()=>{
              try{
                const response = await getDocument(loginData[0]?.personalInfo?.image);
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const  url = URL.createObjectURL(blob);
             setImage(url)
              }catch(err){
                console.log(err)
              }
        
             }
             if (loginData?.[0]?.personalInfo?.image) {
              fetchphoto();
            }
            
// eslint-disable-next-line
  },[])

  const [isScrolled, setIsScrolled] = useState(false);
    const { isOpen, onToggle } = useDisclosure();
  
    // Determine if we're in mobile view
    const isMobile = useBreakpointValue({ base: true, lg: false });

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { text: "About Us", href: `${wpBaseUrl}/about-us/` },
        { text: "Request a demo", href: `${wpBaseUrl}/contact-us/` },
        { text: "Buy Subscription", href: `${wpBaseUrl}/b2c/` },
        { text: "Career", href: `${wpBaseUrl}/why-pococare/` },
        { text: "Blog", href: `${wpBaseUrl}/blog/` },
    ];

  
  return (
    <>
      <Box className={Navstyle.navbar} height={ isMobile ? "4.25rem":"5rem"} p={"1rem 2rem"} backgroundColor={ !isLargerThan768 ? "#F4F7F8" : "var(--white-color)"}>
        <Flex w={"100%"} alignItems={"center"} justifyContent={"space-between"}>
           {
            benificiaryData.length > 0 &&
            <HStack className={Navstyle.navAlign}>
            <Box>
              {
              location.pathname.startsWith('/planDetails') ||  
              location.pathname.startsWith('/buysubscription') || 
              location.pathname.startsWith('/registration') || 
              location.pathname.startsWith('/subscription')||
              location.pathname.startsWith('/dashboard')
              ? 
              <Image
                cursor={"default"}
                // onClick={handleLogoClick}
                width={{ base: "125", md: "150" }}
                height={{ base: "45", md: "57" }}
                src="/Images/logo.png"
                alt="logo"
              />
              :
              <Image
                cursor={"pointer"}
                onClick={handleLogoClick}
                width={{ base: "125", md: "150" }}
                height={{ base: "45", md: "57" }}
                src="/Images/logo.png"
                alt="logo"
              />
            } 
            </Box>
          </HStack>
            
           }
           {
            benificiaryData.length <=0 &&
            (<Box>
               <HStack className={Navstyle.navAlign}>
            <Box>
              {
              location.pathname.startsWith('/planDetails') ||  
              location.pathname.startsWith('/buysubscription') || 
              location.pathname.startsWith('/registration') || 
              location.pathname.startsWith('/subscription')
              ? 
              <Image
                    cursor="default"
                    pointerEvents="none"
                    opacity={0.6}
                // onClick={handleLogoClick}
                width={{ base: "125", md: "150" }}
                height={{ base: "45", md: "57" }}
                src="/Images/logo.png"
                alt="logo"
              />
              :
              <Image
                cursor={"pointer"}
                onClick={handleLogoClick}
                width={{ base: "125", md: "150" }}
                height={{ base: "45", md: "57" }}
                src="/Images/logo.png"
                alt="logo"
              />
            } 
            </Box>
          </HStack>

          <Box
                      position="fixed"
                      top="0"
                      left="0"
                      right="0"
                      zIndex="1000"
                      bg="white"
                      transition="all 0.5s ease"
                      height={isMobile ? (isScrolled ? "66.25px" : "84.26px") : (isScrolled ? "86.25px" : "132.387px")}
                      boxShadow={isScrolled ? "md" : "none"}
                      maxWidth="100%"
                  >
                      <Flex
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                          alignItems="center"
                          height="100%"
                          maxWidth="100%"
                          paddingX={{ base: "15px", md: "40px" }}
                          paddingY={"10px"}
                      >
                          <Box
                              transition="all 0.5s ease"
                              width={isScrolled ? "150px" : isMobile ? "160px" : "234px"}
                              onClick={() => window.open(`${wpBaseUrl}/home/`, "_self")}
                              sx={{ cursor: "pointer" }}
                          >
                              <Image
                                  src={pocoLogo}
                                  width={"100%"}
                                  height={"100%"}
                                  objectFit="contain"
                                  alt="Company Logo"
                                  sx={{ pointerEvents: "none" }}
                              />
                          </Box>
                         
          
          
                          {!isMobile ? (
                              <Flex
                                  justifyContent={"space-between"}
                                  alignItems={"center"}
                                  gap={"61.6px"}
                                  boxSizing="border-box"
                                  paddingRight={"10px"}
                              >
                                  {navLinks.map((link) => (
                                      <Link
                                          key={link.text}
                                          href={link.href}
                                          className={styles.navTextStyle}
                                          _hover={{ color: "red" }}
                                      >
                                          {link.text}
                                      </Link>
                                  ))}
                                  <LoginButtonWithDropdown />
                              </Flex>
                          ) : (
                              <>
                                  <IconButton
                                      onClick={onToggle}
                                      icon={isOpen ? <CustomClose /> : <CustomHamburger />}
                                      variant={"ghost"}
                                      aria-label={"Toggle Navigation"}
                                      color="red.500"
                                  />
                              </>
                          )}
                      </Flex>
          
                      {/* Mobile menu */}
                      {isMobile && isOpen && (
                        
                          <Box
                              bg="white"
                              px={4}
                              pb={4}
                              boxShadow="md"
                          >
                            
                              <VStack as={"nav"} spacing={1} padding={"15px"}>
                                  {navLinks.map((link) => (
                                      <Link
                                          key={link.text}
                                          href={link.href}
                                          className={styles.navTextStyle}
                                          _hover={{ color: "red" }}
                                          w="full"
                                          textAlign="left"
                                          py={2}
                                          borderBottom="0.5px ridge"
                                          borderBottomColor="rgba(0, 0, 0, 0.2)"
                                          padding={"15px"}
                                          letterSpacing={"0px"}
                                          fontFamily={"Poppins, sans-serif"}
                                      >
                                          {link.text}
                                      </Link>
                                  ))}
                                  <Box w="full" textAlign="center" py={2}>
                                      <LoginButtonWithDropdown />
                                  </Box>
                              </VStack>
                          </Box>
                      )}
                  </Box>
            </Box>)
           }

{benificiaryData.length > 0 &&  (
            <HStack className={Navstyle.navAlign} spacing={3}>
              <Menu>
                <MenuButton
                  as={Button}
                  rounded={"full"}
                  variant={"link"}
                  cursor={"pointer"}
                  minW={0}
                  isDisabled = {location.pathname.startsWith('/planDetails') || 
                                location.pathname.startsWith('/buysubscription') || 
                                location.pathname.startsWith('/registration') || 
                                location.pathname.startsWith('/subscription') ||
                                location.pathname.startsWith('/addBenMinDetails') }
                >
                  <Avatar
                    style={{ marginLeft: "10px" }}
                    size={"sm"}
                    src={
                      loginData
                        ?image
                        : ""
                    }
                  />
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
                  <MenuItem onClick={handleTicketsClick}>Tickets</MenuItem>
                  <MenuItem onClick={handleOrdersClick}>Subscription</MenuItem>
                  <MenuItem onClick={logoutHandler}>Logout</MenuItem>
                </MenuList>

              </Menu>
              {/* Standalone Logout button — shown only on payment/subscription pages
                  where the Avatar dropdown is intentionally disabled */}
              {(location.pathname.startsWith('/planDetails') ||
                location.pathname.startsWith('/subscription') ||
                location.pathname.startsWith('/addBenMinDetails')) && (
                isMobile ? (
                  <IconButton
                    aria-label="Logout"
                    icon={<LogoutIcon />}
                    size="sm"
                    variant="outline"
                    borderColor="#00A7B5"
                    color="#00A7B5"
                    borderRadius="8px"
                    _hover={{ bg: "#00A7B5", color: "white" }}
                    onClick={logoutHandler}
                  />
                ) : (
                  <Button
                    size="sm"
                    variant="outline"
                    borderColor="#00A7B5"
                    color="#00A7B5"
                    fontFamily="Poppins"
                    borderRadius="8px"
                    _hover={{ bg: "#00A7B5", color: "white" }}
                    onClick={logoutHandler}
                  >
                    Logout
                  </Button>
                )
              )}
            </HStack>
          )}
        </Flex>
      </Box>

      <Login loginModal={loginModal} onClose={closeModal} />
    </>
  );
};


const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const CustomHamburger = () => (
  <svg width="27" height="27" viewBox="0 0 25 25">
      <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="3" // Makes lines thicker
          strokeLinecap="round"
          d="M4 6h16M4 12h16M4 18h16"
      />
  </svg>
);

const CustomClose = () => (
  <svg width="27" height="27" viewBox="0 0 25 25">
      <rect
          x="3" y="3"
          width="18" height="18"
          rx="2"
          fill="none"
          stroke="red"
          strokeWidth="2"
      />
      <path
          stroke="red"
          strokeWidth="2"
          strokeLinecap="round"
          d="M8 8l8 8M16 8l-8 8"
      />
  </svg>
);
export default Navbar;
